import script from "./SettlementSettingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementSettingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementSettingsModal.vue?vue&type=style&index=0&id=5563e0e7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5563e0e7"]])

export default __exports__